'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { SliderProps as RadixSliderProps } from '@radix-ui/react-slider';
import * as RadixSlider from '@radix-ui/react-slider';
interface SliderProps extends RadixSliderProps {
  min: number;
  max: number;
  value: number[];
  range: number;
  className?: string;
}
export const Slider = t0 => {
  const $ = _c(27);
  let className;
  let max;
  let min;
  let props;
  let range;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      value,
      min,
      max,
      range,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = max;
    $[3] = min;
    $[4] = props;
    $[5] = range;
    $[6] = value;
  } else {
    className = $[1];
    max = $[2];
    min = $[3];
    props = $[4];
    range = $[5];
    value = $[6];
  }
  const extendedRange = range * 1.1;
  const t1 = Math.max(0, (value[0] - extendedRange - min) / (max - min) * 100);
  let t2;
  if ($[7] !== t1) {
    t2 = t1.toFixed(5);
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const left = `${t2}%`;
  const t3 = Math.max(0, 100 - (value[0] + extendedRange - min) / (max - min) * 100);
  let t4;
  if ($[9] !== t3) {
    t4 = t3.toFixed(5);
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const right = `${t4}%`;
  let t5;
  if ($[11] !== className) {
    t5 = cn("relative flex h-6 touch-none select-none items-center bg-Gray-300", className);
    $[11] = className;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== left || $[14] !== right) {
    t6 = <div className="absolute h-full" style={{
      left,
      right,
      background: "linear-gradient(\n                to right, \n                rgba(73, 176, 255, 0) 0%, \n                rgba(73, 176, 255, 1) 15%, \n                rgba(73, 176, 255, 1) 85%, \n                rgba(73, 176, 255, 0) 100%\n              )"
    }} />;
    $[13] = left;
    $[14] = right;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RadixSlider.Range className="absolute rounded-pill" />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6) {
    t8 = <RadixSlider.Track className="relative h-6 grow cursor-pointer"><div className="relative h-full">{t6}{t7}</div></RadixSlider.Track>;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <RadixSlider.Thumb className={cn("block size-20 rounded-pill border-4 border-B-300 bg-Gray-white", "transition-transform duration-200 ease-in-out", "focus:shadow-none focus:outline-none focus:ring-0", "cursor-pointer hover:scale-125 active:scale-95")} />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== max || $[21] !== min || $[22] !== props || $[23] !== t5 || $[24] !== t8 || $[25] !== value) {
    t10 = <RadixSlider.Root max={max} min={min} value={value} {...props} className={t5}>{t8}{t9}</RadixSlider.Root>;
    $[20] = max;
    $[21] = min;
    $[22] = props;
    $[23] = t5;
    $[24] = t8;
    $[25] = value;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};